"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Emil PublicAPI
 * The Emil Public API description
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kontakt@emil.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadsApi = exports.LeadsApiFactory = exports.LeadsApiFp = exports.LeadsApiAxiosParamCreator = void 0;
var axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * LeadsApi - axios parameter creator
 * @export
 */
var LeadsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * This will create a lead. Lead creation is the first step of a workflow responsible for      the creation of an account, policy, banking information.
         * @summary Create the lead
         * @param {CreateLeadRequestDto} createLeadRequestDto
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLead: function (createLeadRequestDto, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createLeadRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('createLead', 'createLeadRequestDto', createLeadRequestDto);
                            localVarPath = "/publicapi/v1/leads";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createLeadRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This will send the lead to the queue for creation. Should be used when creating multiple leads     at the same time - also called \'batch processing\'.
         * @summary Create the lead asynchronously
         * @param {CreateLeadRequestDto} createLeadRequestDto
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLeadAsync: function (createLeadRequestDto, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createLeadRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('createLeadAsync', 'createLeadRequestDto', createLeadRequestDto);
                            localVarPath = "/publicapi/v1/leads-async";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createLeadRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint initiates the creation of a lead, which is the initial step in a comprehensive      workflow responsible for the creation of an account, policy, and banking information.      Unlike the standard lead creation endpoint, this variant ensures that the process waits until the entire workflow      is successfully completed before providing a response.
         * @summary Create the lead synchronously
         * @param {CreateLeadRequestDto} createLeadRequestDto
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLeadSync: function (createLeadRequestDto, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createLeadRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('createLeadSync', 'createLeadRequestDto', createLeadRequestDto);
                            localVarPath = "/publicapi/v1/leads-sync";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createLeadRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves the details of the lead that was previously created. Supply the unique lead code that was returned when you created it and Emil Api will return the corresponding lead information.
         * @summary Retrieve the lead
         * @param {string} code Unique identifier for the object.
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLead: function (code, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'code' is not null or undefined
                            (0, common_1.assertParamExists)('getLead', 'code', code);
                            localVarPath = "/publicapi/v1/leads/{code}"
                                .replace("{".concat("code", "}"), encodeURIComponent(String(code)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This will initiate a lead code.
         * @summary Initiate a lead code
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateLead: function (authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/publicapi/v1/leads/initiate";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates the specified lead by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
         * @summary Update the lead
         * @param {string} code Unique identifier for the object.
         * @param {UpdateLeadRequestDto} updateLeadRequestDto
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLead: function (code, updateLeadRequestDto, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'code' is not null or undefined
                            (0, common_1.assertParamExists)('updateLead', 'code', code);
                            // verify required parameter 'updateLeadRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('updateLead', 'updateLeadRequestDto', updateLeadRequestDto);
                            localVarPath = "/publicapi/v1/leads/{code}"
                                .replace("{".concat("code", "}"), encodeURIComponent(String(code)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateLeadRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates the specified lead by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
         * @summary Update the lead
         * @param {string} code Unique identifier for the object.
         * @param {UpdateLeadRequestDto} updateLeadRequestDto
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLeadSync: function (code, updateLeadRequestDto, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'code' is not null or undefined
                            (0, common_1.assertParamExists)('updateLeadSync', 'code', code);
                            // verify required parameter 'updateLeadRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('updateLeadSync', 'updateLeadRequestDto', updateLeadRequestDto);
                            localVarPath = "/publicapi/v1/leads-sync/{code}"
                                .replace("{".concat("code", "}"), encodeURIComponent(String(code)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateLeadRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.LeadsApiAxiosParamCreator = LeadsApiAxiosParamCreator;
/**
 * LeadsApi - functional programming interface
 * @export
 */
var LeadsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LeadsApiAxiosParamCreator)(configuration);
    return {
        /**
         * This will create a lead. Lead creation is the first step of a workflow responsible for      the creation of an account, policy, banking information.
         * @summary Create the lead
         * @param {CreateLeadRequestDto} createLeadRequestDto
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLead: function (createLeadRequestDto, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createLead(createLeadRequestDto, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This will send the lead to the queue for creation. Should be used when creating multiple leads     at the same time - also called \'batch processing\'.
         * @summary Create the lead asynchronously
         * @param {CreateLeadRequestDto} createLeadRequestDto
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLeadAsync: function (createLeadRequestDto, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createLeadAsync(createLeadRequestDto, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This endpoint initiates the creation of a lead, which is the initial step in a comprehensive      workflow responsible for the creation of an account, policy, and banking information.      Unlike the standard lead creation endpoint, this variant ensures that the process waits until the entire workflow      is successfully completed before providing a response.
         * @summary Create the lead synchronously
         * @param {CreateLeadRequestDto} createLeadRequestDto
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLeadSync: function (createLeadRequestDto, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createLeadSync(createLeadRequestDto, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieves the details of the lead that was previously created. Supply the unique lead code that was returned when you created it and Emil Api will return the corresponding lead information.
         * @summary Retrieve the lead
         * @param {string} code Unique identifier for the object.
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLead: function (code, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLead(code, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This will initiate a lead code.
         * @summary Initiate a lead code
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateLead: function (authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.initiateLead(authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates the specified lead by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
         * @summary Update the lead
         * @param {string} code Unique identifier for the object.
         * @param {UpdateLeadRequestDto} updateLeadRequestDto
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLead: function (code, updateLeadRequestDto, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateLead(code, updateLeadRequestDto, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates the specified lead by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
         * @summary Update the lead
         * @param {string} code Unique identifier for the object.
         * @param {UpdateLeadRequestDto} updateLeadRequestDto
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLeadSync: function (code, updateLeadRequestDto, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateLeadSync(code, updateLeadRequestDto, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.LeadsApiFp = LeadsApiFp;
/**
 * LeadsApi - factory interface
 * @export
 */
var LeadsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LeadsApiFp)(configuration);
    return {
        /**
         * This will create a lead. Lead creation is the first step of a workflow responsible for      the creation of an account, policy, banking information.
         * @summary Create the lead
         * @param {CreateLeadRequestDto} createLeadRequestDto
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLead: function (createLeadRequestDto, authorization, options) {
            return localVarFp.createLead(createLeadRequestDto, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This will send the lead to the queue for creation. Should be used when creating multiple leads     at the same time - also called \'batch processing\'.
         * @summary Create the lead asynchronously
         * @param {CreateLeadRequestDto} createLeadRequestDto
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLeadAsync: function (createLeadRequestDto, authorization, options) {
            return localVarFp.createLeadAsync(createLeadRequestDto, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint initiates the creation of a lead, which is the initial step in a comprehensive      workflow responsible for the creation of an account, policy, and banking information.      Unlike the standard lead creation endpoint, this variant ensures that the process waits until the entire workflow      is successfully completed before providing a response.
         * @summary Create the lead synchronously
         * @param {CreateLeadRequestDto} createLeadRequestDto
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLeadSync: function (createLeadRequestDto, authorization, options) {
            return localVarFp.createLeadSync(createLeadRequestDto, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves the details of the lead that was previously created. Supply the unique lead code that was returned when you created it and Emil Api will return the corresponding lead information.
         * @summary Retrieve the lead
         * @param {string} code Unique identifier for the object.
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLead: function (code, authorization, options) {
            return localVarFp.getLead(code, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This will initiate a lead code.
         * @summary Initiate a lead code
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateLead: function (authorization, options) {
            return localVarFp.initiateLead(authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates the specified lead by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
         * @summary Update the lead
         * @param {string} code Unique identifier for the object.
         * @param {UpdateLeadRequestDto} updateLeadRequestDto
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLead: function (code, updateLeadRequestDto, authorization, options) {
            return localVarFp.updateLead(code, updateLeadRequestDto, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates the specified lead by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
         * @summary Update the lead
         * @param {string} code Unique identifier for the object.
         * @param {UpdateLeadRequestDto} updateLeadRequestDto
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLeadSync: function (code, updateLeadRequestDto, authorization, options) {
            return localVarFp.updateLeadSync(code, updateLeadRequestDto, authorization, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LeadsApiFactory = LeadsApiFactory;
/**
 * LeadsApi - object-oriented interface
 * @export
 * @class LeadsApi
 * @extends {BaseAPI}
 */
var LeadsApi = /** @class */ (function (_super) {
    __extends(LeadsApi, _super);
    function LeadsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This will create a lead. Lead creation is the first step of a workflow responsible for      the creation of an account, policy, banking information.
     * @summary Create the lead
     * @param {LeadsApiCreateLeadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApi
     */
    LeadsApi.prototype.createLead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LeadsApiFp)(this.configuration).createLead(requestParameters.createLeadRequestDto, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This will send the lead to the queue for creation. Should be used when creating multiple leads     at the same time - also called \'batch processing\'.
     * @summary Create the lead asynchronously
     * @param {LeadsApiCreateLeadAsyncRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApi
     */
    LeadsApi.prototype.createLeadAsync = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LeadsApiFp)(this.configuration).createLeadAsync(requestParameters.createLeadRequestDto, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint initiates the creation of a lead, which is the initial step in a comprehensive      workflow responsible for the creation of an account, policy, and banking information.      Unlike the standard lead creation endpoint, this variant ensures that the process waits until the entire workflow      is successfully completed before providing a response.
     * @summary Create the lead synchronously
     * @param {LeadsApiCreateLeadSyncRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApi
     */
    LeadsApi.prototype.createLeadSync = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LeadsApiFp)(this.configuration).createLeadSync(requestParameters.createLeadRequestDto, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves the details of the lead that was previously created. Supply the unique lead code that was returned when you created it and Emil Api will return the corresponding lead information.
     * @summary Retrieve the lead
     * @param {LeadsApiGetLeadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApi
     */
    LeadsApi.prototype.getLead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LeadsApiFp)(this.configuration).getLead(requestParameters.code, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This will initiate a lead code.
     * @summary Initiate a lead code
     * @param {LeadsApiInitiateLeadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApi
     */
    LeadsApi.prototype.initiateLead = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.LeadsApiFp)(this.configuration).initiateLead(requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates the specified lead by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
     * @summary Update the lead
     * @param {LeadsApiUpdateLeadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApi
     */
    LeadsApi.prototype.updateLead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LeadsApiFp)(this.configuration).updateLead(requestParameters.code, requestParameters.updateLeadRequestDto, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates the specified lead by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
     * @summary Update the lead
     * @param {LeadsApiUpdateLeadSyncRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApi
     */
    LeadsApi.prototype.updateLeadSync = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LeadsApiFp)(this.configuration).updateLeadSync(requestParameters.code, requestParameters.updateLeadRequestDto, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LeadsApi;
}(base_1.BaseAPI));
exports.LeadsApi = LeadsApi;
